import availabilitiesStore from './availabilities'
import bookingsStore from './bookings'
import promotionsStore from './promotions'

export default {
  modules: {
    availabilities: {
      namespaced: true,
      ...availabilitiesStore
    },
    bookings: {
      namespaced: true,
      ...bookingsStore
    },
    promotions: {
      namespaced: true,
      ...promotionsStore
    }
  }
}
